import { Validation, Messages } from 'utils/forms/validations';

export const validate = (values) => {
  const errors = {};
  let formHasErrors = false;

  let validationResult = Validation.email(values.email, true);
  if (validationResult) {
    errors.email = validationResult;
    formHasErrors = true;
  }

  validationResult = Validation.required(values.password);
  if (validationResult) {
    errors.password = validationResult;
    formHasErrors = true;
  }

  if (formHasErrors) {
    errors._error = Messages.FILL_IN_ALL;
  }

  return errors;
};
